var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangePerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_52_1683",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_52_1683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.22914 18.1625H6.50237L15.8643 8.79457L14.5911 7.52053L5.22914 16.8884V18.1625ZM3.43164 19.9611V16.139L15.8643 3.69843C16.0474 3.51524 16.2458 3.382 16.4595 3.29873C16.6731 3.21546 16.8977 3.17383 17.1336 3.17383C17.3693 3.17383 17.5953 3.21546 17.8116 3.29873C18.028 3.382 18.2277 3.51524 18.4108 3.69843L19.684 4.97247C19.8671 5.15566 20.0003 5.35551 20.0835 5.57201C20.1667 5.78851 20.2083 6.00951 20.2083 6.23501C20.2083 6.47566 20.1665 6.70499 20.083 6.92299C19.9994 7.14099 19.8664 7.34017 19.684 7.52053L7.25133 19.9611H3.43164ZM15.2165 8.16879L14.5911 7.52053L15.8643 8.79457L15.2165 8.16879Z",
    fill: "#5386E4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePerson);
export default __webpack_public_path__ + "static/media/change-person.952365e59badd8583c40d148b4d31cab.svg";
export { ForwardRef as ReactComponent };